module.exports = __webpack_public_path__ + "img/noComplaints.b29bd539.png";